export default "__VITE_ASSET__DGC9oGuV__"